import { cn } from '../../utils';
import type { WidgetSize } from '../../types';
import { useT } from '../../i18n';
import styles from './ChatButton.module.css';

export interface ChatButtonProps {
  iconUrl?: string;
  size?: WidgetSize;
  onClick?: () => void;
  className?: string;
}

const DEFAULT_ICON_URL =
  'https://sjmfgzreweismxbtpksw.supabase.co/storage/v1/object/public/assets/merchant/merc_cShSlbrYLgrVQsAPJb4R/1764064532950-yjxxpudz46.png';

export function ChatButton({
  iconUrl = DEFAULT_ICON_URL,
  size = 'normal',
  onClick,
  className,
}: ChatButtonProps) {
  const t = useT();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.buttonWrapper}>
        <button className={styles.button} onClick={onClick} type="button">
          <img
            src={iconUrl}
            className={cn(styles.icon, size === 'small' ? styles.small : styles.normal)}
            alt={t('common.chatAlt')}
          />
        </button>
      </div>
    </div>
  );
}
